import React from 'react';

export const ARROW_ICON_URL = 'https://adn-static1.nykaa.com/media/wysiwyg/2022/dwn-aroww.png';

export const RIGHT_ARROW_ICON_SIZE = '24px';

export const FAQ = 'FAQs';

export const TERMS_AND_CONDITIONS = 'Terms & Conditions';

export const VIEW_MORE_FAQS = 'View more FAQs';

export const faqList = [
  {
    question: 'What is FLX?',
    answer: (
      <>
        <p>
          <strong>FLX is Foot Locker’s exclusive loyalty program.</strong>
        </p>
        <p>
          Designed to reward our most valued customers, FLX gives you access to special benefits and
          exclusive rewards. All you have to do is shop with us, either online or in-store, to
          become a member and start unlocking the perks.
        </p>
      </>
    ),
  },
  {
    question: 'How do I earn points?',
    answer: (
      <>
        <p>
          Earn points every time you make a purchase with us. (You earn 4 points for every Rs 100
          you spend shopping in our stores or online.) Here’s how:
        </p>
        <ol>
          <li>
            <p>
              <strong>Shop at a store</strong>
            </p>
            <p>
              When you’re ready to check out, show a store team member your FLX Rewards history on
              our website or provide your email address or mobile number.
            </p>
          </li>
          <li>
            <p>
              <strong>Shop online</strong>
            </p>
            <p>
              Log in using your registered mobile number, and your points will be added to your
              wallet once your purchase is complete.
            </p>
          </li>
        </ol>
      </>
    ),
  },
  {
    question: 'How do I redeem points?',
    answer: (
      <>
        <ol>
          <li>
            <p>Visit the FLX Dashboard to check your available points balance.</p>
          </li>
          <li>
            <p>
              Use your points to unlock rewards, which will be applied as discounts directly to your
              cart.
            </p>
          </li>
          <li>
            <p>
              You can also present your rewards to our store team to redeem points during an
              in-store purchase.
            </p>
          </li>
        </ol>
        <p>
          Please note that you must have a minimum balance of 50 points in your rewards wallet to be
          eligible for points redemption.
        </p>
      </>
    ),
  },
];
